import React from "react";
import styles from "../styles/hero.module.scss";
import { translations } from "../translation";
import { HeroSectionProps } from "../types";

const HeroSection = ({ language }: HeroSectionProps) => {
	const t = translations[language];
	const videoUrl: string = "https://demo-newtoms.s3.us-east-1.amazonaws.com/APK+Consumer+Pro/brainVid.mov";

	return (
		<section className={`bg-light py-5 ${styles["hero-gradient-background"]}`} id="hero">
			<video className={`${styles["hero-video"]}`} autoPlay muted loop playsInline>
				<source src={videoUrl} type="video/mp4" />
			</video>
			<div className={`${styles["hero-overlay"]}`}></div>

			<div className={`container text-center mt-4 ${styles["hero-text"]}`}>
				<h1 className="display-5 fw-bold mb-3">{t.heroTitle}</h1>
				<h1 className="display-6 fw-bold mb-3">{t.heroTitle2}</h1>
				<p className="lead mb-4">{t.heroDescription}</p>
				<div className="d-flex justify-content-center gap-3">
					<button className="btn btn-primary ">{t.heroBtn1}</button>
					<button className="btn btn-outline-primary ">
						<a className=" text-decoration-none text-white" href="#contact-us">
							{t.heroBtn2}
						</a>
					</button>
				</div>
			</div>
		</section>
	);
};

export default HeroSection;
